export default __webpack_public_path__ + "./fonts/checkbox-unchecked.478eecd3.svg";